import {createRoot, hydrateRoot} from 'react-dom/client';
import CaseStudies from '../pages/CaseStudies/CaseStudies'
import "../index.css";
import "../pages/CaseStudies/CaseStudies.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<CaseStudies {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <CaseStudies {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).CaseStudiesVC = {mount, hydrate, unmount}